export type ID32Value = Int32Array;

export class ID32 {
  public readonly id: ID32Value = new Int32Array(4);

  /**
   * Sets an index in an id
   * @param index - index to set in the id
   */
  public setIndex(index: number) {
    const id = (index / 31) | 0;

    this.id[id] = this.id[id] | (1 << (index % 31));
  }

  /**
   * Unsets an index in an id
   * @param index - index to unset in the id
   */
  public unsetIndex(index: number) {
    const id = (index / 31) | 0;

    this.id[id] = this.id[id] & ~(1 << (index % 31));
  }

  /**
   * checks if idB contains the same bits as this id
   * @param id - id to compare
   */
  public matchIndex(id: ID32): boolean {
    const q1 = this.id[0];
    const q2 = this.id[1];
    const q3 = this.id[2];
    const q4 = this.id[3];
    const idValue = id.id;

    return (
      ((idValue[0] & q1) ^ q1) +
        ((idValue[1] & q2) ^ q2) +
        ((idValue[2] & q3) ^ q3) +
        ((idValue[3] & q4) ^ q4) ===
      0
    );
  }

  /**
   * checks if any bits in idB match this id
   * @param id - id to compare
   */
  public matchAnyIndex(id: ID32): boolean {
    const q1 = this.id[0];
    const q2 = this.id[1];
    const q3 = this.id[2];
    const q4 = this.id[3];
    const idValue = id.id;

    return (
      (idValue[0] & q1) +
        (idValue[1] & q2) +
        (idValue[2] & q3) +
        (idValue[3] & q4) >
      0
    );
  }
}
